<!--
	@author bluefirex
-->
<template>
	<header class="acquisit-state-inspector-header">
		<div class="title">
			<slot></slot>
			
			<div class="info" v-if="$slots.info">
				<slot name="info"></slot>
			</div>
		</div>
		
		<div class="actions">
			<slot name="actions"></slot>
		</div>
	</header>
</template>

<script setup lang="ts">
	import { useColor, useColorProps } from '@broker-as/acquisit-ui-vue/helpers'
	
	const props = defineProps({
		...useColorProps()
	})
	
	const color = useColor(props)
</script>

<style lang="scss">
	@use '@/assets/mixins.scss' as m;
	
	.acquisit-state-inspector-header {
		display: flex;
		align-items: center;
		
		.title {
			flex-grow: 1;
			line-height: 1.5;
			
			h2 {
				display: flex;
				align-items: center;
				gap: 8px;
				
				font-weight: 600;
				
				.svg {
					width: 20px;
					height: 20px;
					color: m.color("green") !important;
				}
			}
			
			.info {
				margin-top: 4px;
			}
			
			.flag {
				display: inline-flex;
				align-items: center;
				gap: 8px;
				vertical-align: middle;
				
				--border-color: #{m.color("dark-border")};
				--color: #{m.color("light-grey-blue")};
				
				background: transparent;
				border: 1px solid var(--border-color);
				border-radius: 6px;
				color: var(--color);
				padding: 4px 8px;
				
				.svg {
					width: 16px;
					height: 16px;
				}
				
				& + .flag {
					margin-left: 8px;
				}
				
				&.uid {
					--border-color: #{m.color("amber")};
					--color: #{m.color("amber")};
					font-weight: 600;
				}
				
				&.size {
					--border-color: #{m.color("lime")};
					--color: #{m.color("lime")};
					font-weight: 600;
					
					&.exceeded {
						--border-color: #{m.color("red")};
						--color: #{m.color("red")};
						font-weight: 900;
					}
				}
				
				&.pdf-size {
					--border-color: #{m.color("white")};
					--color: #{m.color("white")};
					font-weight: 600;
					
					&.exceeded {
						--border-color: #{m.color("red")};
						--color: #{m.color("red")};
						font-weight: 900;
					}
				}
				
				&.origin {
					--border-color: #{m.color("purple")};
					--color: #{m.color("purple")};
					font-weight: 600;
				}
				
				&.copyable {
					user-select: all;
				}
			}
			
			.secondary {
				color: v-bind("color.textSecondary.value.cssHSLA");
			}
		}
		
		.actions {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			gap: 20px;
		}
		
		@include m.media(mobile) {
			display: block;
			
			.actions {
				margin-top: 16px;
			}
		}
	}
</style>